export default {
  outcomeNoAction: 'No action',
  outcomeVerbalWarning: 'Verbal warning',
  outcomeWrittenWarning: 'Written warning',
  outcomeFinalWarning: 'Final warning',
  outcomeSuspension: 'Suspension',
  outcomeTermination: 'Termination',
  goalNotStarted: 'Not started',
  goalInProgress: 'In progress',
  goalDone: 'Done',
  goalCancelled: 'Cancelled',
  gridStar: 'Star',
  gridHighPerformer: 'High performer',
  gridTrustedProfessional: 'Trusted professional',
  gridRisingStar: 'Rising star',
  gridCorePlayer: 'Core player',
  gridSolidContributor: 'Solid contributor',
  gridEnigma: 'Enigma',
  gridInconsistent: 'Inconsistent',
  gridUnderperformer: 'Underperformer',
  gridUnrated: 'Unrated',
  tabReviews: 'Reviews',
  tabNineBox: '9-box',
  tabNotes: 'Management notes',
  tabDisciplinary: 'Disciplinary',
  tabGoals: 'Goals',
  reviews: 'Reviews',
  noReviewsTitle: 'No reviews yet',
  noReviewsMessage: 'Reviews appear here once a review period is launched from the Performance page.',
  submitted: 'Submitted',
  draft: 'Draft',
  averageOf5: 'Average {average} of 5',
  criteriaRated: '{rated} of {total} criteria rated',
  view: 'View',
  rate: 'Rate',
  reviewSubmitted: 'Review submitted.',
  draftSaved: 'Draft saved.',
  reviewTitle: '{period} review',
  criterionRating: '{criterion} rating',
  criterionComment: '{criterion} comment',
  commentOptional: 'Comment (optional)',
  overallComment: 'Overall comment',
  saveDraft: 'Save draft',
  submitReview: 'Submit review',
  nineBoxTitle: '9-box talent grid',
  potential: 'Potential',
  performance: 'Performance',
  cellAriaLabel: '{label}: performance {performance}, potential {potential}',
  pickCell: 'Pick a cell for the new rating: <b>{label}</b>. The highlighted cell is the current rating; earlier ratings are kept as history.',
  notesOptional: 'Notes (optional)',
  ratingSaved: 'Rating saved.',
  saveRating: 'Save rating',
  noRatings: 'No ratings submitted yet.',
  managementNotes: 'Management notes',
  writeNote: 'Write a note',
  notesPrivate: 'Private to managers. Never shown to the employee.',
  noNotesTitle: 'No management notes yet',
  noNotesMessage: 'Keep a running record of check-ins and observations.',
  unknownAuthor: 'Unknown',
  newNoteTitle: 'New management note',
  noteAdded: 'Note added.',
  subject: 'Subject',
  note: 'Note',
  saveNote: 'Save note',
  disciplinaryRecord: 'Disciplinary record',
  createDisciplinary: 'Create disciplinary',
  editDisciplinary: 'Edit disciplinary',
  disciplinaryHelp: "Drafts are only visible to admins. Publishing adds the record to the employee's file and locks it.",
  noDisciplinaryTitle: 'No disciplinary matters',
  noDisciplinaryMessage: 'Nothing has been recorded for this employee.',
  published: 'Published',
  publishedToast: 'Published.',
  publish: 'Publish',
  stepsTakenValue: 'Steps taken: {steps}',
  disciplinaryDraftHelp: 'Draft disciplinaries are only visible to admins.',
  incident: 'Incident',
  incidentPlaceholder: 'A name or brief summary',
  incidentDate: 'Date of incident',
  outcome: 'Outcome',
  description: 'Description',
  stepsTaken: 'What steps were taken?',
  saveAsDraft: 'Save as draft',
  goals: 'Goals',
  createGoal: 'Create goal',
  updateGoal: 'Update goal',
  noGoalsTitle: 'No goals set yet',
  noGoalsMessage: 'Create a goal to track what this person is working towards.',
  overdue: 'Overdue',
  teamGoal: 'Team goal',
  individual: 'Individual',
  dueOn: ' · due {date}',
  update: 'Update',
  goalProgress: '{name} progress',
  goalUpdated: 'Goal updated.',
  goalCreated: 'Goal created.',
  descriptionOptional: 'Description (optional)',
  owner: 'Owner',
  selectEmployee: 'Select an employee',
  dueDate: 'Due date',
  goalType: 'Goal type',
  team: 'Team',
  progressPercent: 'Progress ({percent}%)',
  visibleTo: 'Visible to',
  visibilityParticipants: 'Participants: owner and their managers',
  visibilityManagers: 'Managers only',
  visibilityEveryone: 'Everyone',
  saveGoal: 'Save goal',
}
